import TradingOfferOperationDetail from 'modules/trading/pages/TradingOfferOperationDetail';
import { TradingOfferOperationDetailProvider } from '../contexts/TradingOfferOperationDetailContext';

const TradingOfferOperationDetailContainer = () => (
  <TradingOfferOperationDetailProvider>
    <TradingOfferOperationDetail />
  </TradingOfferOperationDetailProvider>
);

export default TradingOfferOperationDetailContainer;
